import { Component } from '@angular/core';
import { Router, CanActivate,ActivatedRoute,Params  } from '@angular/router';
import { ApicTokenService } from 'src/app/Services/apic-token-service';
import { HttpParams, HttpClient } from '@angular/common/http';
import { ApicPKCEResponse, MyProfileData } from 'src/app/Model/api-model';
import { RestApiService } from 'src/app/Services/rest-api-service';

import CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';
import { AppListResponse } from 'src/app/Model/apilistresponse-model';

@Component({
  selector: 'app-landing',
  templateUrl: './welcome.component.html'
})

export class LandingComponent {
  display=false;  
  token:string;
  myData;
 errorUserProfile=false;
 appList:AppListResponse=new AppListResponse();
 message;
displayErrorMSG='';
spinner=false;
 constructor(private httpClient: HttpClient,  private route: ActivatedRoute,private restApiBoot: RestApiService,public router: Router,private restApi: ApicTokenService) {
   // console.log('Called Constructor');
    this.route.queryParams.subscribe(params => {
    this.token=params['code'];
   // console.log("token is "+this.token)
      if(this.token==null){
    //    console.log('inside if'+this.token);

    localStorage.setItem("is_cuurent_nav_aem","y");

      //  localStorage.clear(); 
      //  sessionStorage.clear();
      }else{
    //    console.log('inside else'+this.token);
        this.loadAppToken(this.token);
      // localStorage.setItem('devportal_apic_token', this.token);
   
       // this.router.navigate(['dashboard']);
      }

    });

 

  }//end of cons


  tokenResponse:ApicPKCEResponse;
  loadAppToken(code) {

    this.display=true;
    this.spinner=true;
    const client_id=environment.getAmClientId();
    const code_verifier=sessionStorage.getItem("code_verifier");
 //   const body = new URLSearchParams();
 //    body.set('code', code);
 //    body.set('grant_type', 'authorization_code');
 //    body.set('client_id',client_id);
//     body.set('code_verifier',code_verifier);


     const bdy = `code=${code}&client_id=${client_id}&code_verifier=${code_verifier}&grant_type=authorization_code`;

   //  console.log("to see body "+bdy)
     return this.restApi.getToken_PostRequest(bdy.toString()).subscribe((data: {}) => {
    
    
     this.tokenResponse=data as ApicPKCEResponse;
      localStorage.removeItem("code_verifier");
      sessionStorage.removeItem("code_verifier");
      localStorage.setItem('devportal_apic_token', this.tokenResponse.access_token);
      localStorage.setItem('devportal_id_token', this.tokenResponse.id_token);
      
     this.loadMyProfile();
     this.displayErrorMSG='';
    },(error)=>{
        console.log("error is "+error)
        this.displayErrorMSG=error;
        this.spinner=false;
       
     
      })
  }

  loadMyProfile(){
        
    return this.restApiBoot.myProfile_Get().subscribe((data: {}) => {
     
      this.myData=data as MyProfileData;
      localStorage.setItem("firstName",this.myData.firstName);
      localStorage.setItem("lastName",this.myData.lastName);
      localStorage.setItem("email_ID",this.myData.emailId);


      localStorage.setItem("devStatus_qu",this.myData.developerQuestionnaireStatus);
      localStorage.setItem("payerStatus_qu",this.myData.payerQuestionnaireStatus);
      localStorage.setItem("brokerStatus_qu",this.myData.brokerQuestionnaireStatus);

      localStorage.setItem("providerStatus_qu",this.myData.providerQuestionnaireStatus);




        localStorage.setItem("org_id_demo",this.myData.sandboxOrgId);
        localStorage.setItem("org_id_prod",this.myData.prodOrgId);
        localStorage.setItem("path","sandbox");

        localStorage.setItem("is_first_load","yes");
     

       if(this.myData.status=='Failure'){
        this.errorUserProfile=true;
         this.message=this.myData.errorMessage;
         this.spinner=false;
       }else{

      

          this.router.navigate(['dashboard']);
        

        
       }
      
 
     },(error)=>{
      this.display=false;
    
      this.displayErrorMSG=error;
      this.spinner=false;
  

       })
 

  }



  loadAppList() {
   
   
    return this.restApiBoot.getAppList().subscribe(async (data: {}) => {
     
     
      this.appList=data as AppListResponse;
  

            if(this.appList.appListView.length!=0){
            
            }else{
              
              localStorage.setItem("devStatus_qu","NA");
              localStorage.setItem("payerStatus_qu","NA");
        
            
            }

            this.router.navigate(['dashboard']);

    },(error)=>{

      this.router.navigate(['dashboard']);
    })




  }










  ngAfterViewInit() {
    // Hack: Scrolls to top of Page after page view initialized
    let top = document.getElementById('top');
    if (top !== null) {
      top.scrollIntoView();
      top = null;
    }
  }


  home_getting_started;
  home_help;
  home_fhir_apis;
  home_announcements;
  ngOnInit(){
      
  
let aemURL=environment.getAemurl()+'/static_content/';


if(environment.getAemurl()=='none'){
  aemURL='/assets/Data/';
 }




    this.httpClient.get(aemURL+"home_getting_started.json").subscribe(data =>{
     //console.log(data);
     this.home_getting_started = data;
      })
      this.httpClient.get(aemURL+"home_help.json").subscribe(data =>{
        //console.log(data);
        this.home_help = data;
         })

         this.httpClient.get(aemURL+"home_fhir_apis.json").subscribe(data =>{
          //console.log(data);
          this.home_fhir_apis = data;
           })


           this.httpClient.get(aemURL+"home_announcements.json").subscribe(data =>{
            //console.log(data);
            this.home_announcements = data;
             })
  


  }//end of ngonit

}
